import { DashboardProductStates } from "config";
import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

const selectEstimateId = (state: RootState) => state.estimate?.id;
const selectPolicy = (state: RootState) => state.policy;
const selectProductOfferings = (state: RootState) => state.productOffering;
const selectInsuranceApplication = (state: RootState) => state.insuranceApplication;
const selectAllocationSummary = (state: RootState) => state.allocationSummary;
const selectWyshAllocations = (state: RootState) => state.wyshAllocations.allocated;

export const getInsuranceProductState = createSelector(
  selectPolicy,
  selectInsuranceApplication,
  selectEstimateId,
  selectProductOfferings,
  (activePolicy, insuranceApplication, estimateId, productOfferings): DashboardProductStates => {
    if (activePolicy.id) {
      return "owned";
    } else if (insuranceApplication.result === "referred_to_underwriter") {
      return "notice";
    } else if (!!productOfferings.ids.length) {
      return "quote";
    } else if (estimateId) {
      return "recapture";
    } else {
      return "marketing";
    }
  }
);

export const getWyshesProductState = createSelector(
  selectWyshAllocations,
  selectAllocationSummary,
  (wyshAllocations, allocationSummary): Extract<DashboardProductStates, "marketing" | "owned"> => {
    if (wyshAllocations.length || allocationSummary.activeCount) {
      return "owned";
    } else {
      return "marketing";
    }
  }
);
